export const SOFTLINE_FEATURE_UPLOAD_ARCHIVE_VOUCHER = 'uploadArchiveVoucher';

export const SOFTLINE_PERMISSION_UPLOAD_ARCHIVE_VOUCHER = 'EINVERKAUFBELEGE';
